import { AuthenticatedTemplate } from "@azure/msal-react";
import { UnauthenticatedTemplate } from "@azure/msal-react";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import { NavigationBar } from "./NavigationBar";

export const PageLayout = (props) => {
  /**
   * Most applications will need to conditionally render certain components based on whether a user is signed in or not.
   * msal-react provides 2 easy ways to do this. AuthenticatedTemplate and UnauthenticatedTemplate components will
   * only render their children if a user is authenticated or unauthenticated, respectively.
   */
  return (
    <>
      <NavigationBar></NavigationBar>
      <Toolbar />
      <UnauthenticatedTemplate>
        <br />
        <h5>
          <center>Please login to your Coder Sports Academy account</center>
        </h5>
      </UnauthenticatedTemplate>
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "center",
          backgroundColor: "#121212",
          minHeight: "calc(100vh - 64px)",
        }}
      >
        {props.children}

        <AuthenticatedTemplate></AuthenticatedTemplate>
      </Box>
    </>
  );
};
